
import { AuditDetails, Entity } from '../entity';
import { DomainType } from '../../utilities/domain.utility';

export enum IpRestrictionLifespan {
  Permanent = 'permanent',
  TwoMinutes = '2m',  // For non-production testing only
  OneHour = '1h',
  TwoHours = '2h',
  FourHours = '4h',
  EightHours = '8h',
  TwentyFourHours = '24h'
}

export enum IpRestrictionType {
  Single = 'single',
  Range = 'range',
  CIDR = 'cidr'
};

export enum IpRestrictionSource {
  User = 'user',
  System = 'system'
}

export enum IpRestrictionCustomAction {
  DeleteAll = 'delete-all',
  GetCurrentIp = 'get-current-ip'
}

export interface IpRestrictionRule extends Entity, AuditDetails {
  description?: string;
  domain?: DomainType;
  type: IpRestrictionType;
  source: IpRestrictionSource;
  lifespan?: IpRestrictionLifespan;
  value: string;
  mask: number;
  enabled: boolean;
  expiresAt?: Date;
  isCurrentIp?: boolean;
}

